import styled from '@emotion/styled';
import { textTruncate } from '@utils/textHelper';
import { Spacings, Fonts } from '@styles/index';
import useEducatorContext from '@hooks/useEducatorContext';

const StyledDescription = styled.span`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P2};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  margin: ${Spacings.SPACING_0B};
  transition: all 300ms ease;
  color: var(--color-text-secondary);
`;

const ReadMore = styled.span`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.P2};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  margin: ${Spacings.SPACING_0B};
  transition: all 300ms ease;
  margin-top: ${Spacings.SPACING_8B};
  color: var(--color-text-secondary);
  cursor: pointer;
`;

const DescriptionWrapper = styled.div`
  margin-top: ${({ isEducatorSide }) =>
    isEducatorSide ? Spacings.SPACING_4B : Spacings.SPACING_8B};
  @media (max-width: 47.95em) {
    margin-top: 12px;
  }
`;

const CourseDescription = ({ children, handleOnReadMore }) => {
  const isEducatorSide = useEducatorContext();

  return (
    <DescriptionWrapper isEducatorSide={isEducatorSide}>
      <StyledDescription>{textTruncate(children, 214)}</StyledDescription>
      <ReadMore onClick={handleOnReadMore}> Read more</ReadMore>
    </DescriptionWrapper>
  );
};

export default CourseDescription;
